import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
const Spinner = ({ size, color, className, isFade }) => {
    const [show, setShow] = useState(false);
    useEffect(() => {
        setShow(true);
    }, []);
    if (!color) {
        color = 'primary';
    }
    if (!size) {
        size = 'm';
    }
    let viewBox;
    let cx;
    let cy;
    let r;
    let strokeWidth;
    switch (size) {
        case 'xs':
            {
                viewBox = '0 0 16 16';
                cx = 8;
                cy = 8;
                r = 6.5;
                strokeWidth = 3;
            }
            break;
        case 's':
            {
                viewBox = '0 0 24 24';
                cx = 12;
                cy = 12;
                r = 10.5;
                strokeWidth = 3;
            }
            break;
        case 'm':
            {
                viewBox = '0 0 32 32';
                cx = 16;
                cy = 16;
                r = 14;
                strokeWidth = 4;
            }
            break;
        case 'l':
            {
                viewBox = '0 0 48 48';
                cx = 24;
                cy = 24;
                r = 21;
                strokeWidth = 6;
            }
            break;
        case 'xl':
            {
                viewBox = '0 0 64 64';
                cx = 32;
                cy = 32;
                r = 28;
                strokeWidth = 8;
            }
            break;
        default: {
            viewBox = '0 0 32 32';
            cx = 16;
            cy = 16;
            r = 14;
            strokeWidth = 4;
        }
    }
    const spinnerClassName = classNames('spinner w-100', size, { fade: isFade }, { show: isFade && show }, className);
    const circleClassName = classNames('path', size, color);
    return (React.createElement("svg", { className: spinnerClassName, viewBox: viewBox, strokeDashoffset: 0, strokeDasharray: `${(10 * r) / 3}, ${(27 * r) / 12}` },
        React.createElement("circle", { className: circleClassName, cx: cx, cy: cy, r: r, fill: "none", strokeWidth: strokeWidth })));
};
export { Spinner };
//# sourceMappingURL=Spinner.js.map